<template>
  <div class="card mat10 flex-s-s">
    <ul class="key-value" style="width:500px;margin-right:40px">
      <li v-for="item in messageList">
        <div class="key">{{item.key}}：</div>
        <div class="value">{{item.value}}</div>
      </li>
    </ul>
    <img src="@images/demo.jpg" class="img" />
  </div>
</template>

<script>
import mModal from '@/components/modal/modal.vue'
export default {
  components: {
    mModal
  },
  data() {
    return {
      messageList: [
        { key: "编号", value: "010-09-22 09:20:09" },
        { key: " 展厅", value: "23131233" },
        { key: " 展厅类型 ", value: "活动类型" },
        { key: "楼层 ", value: "2020-10-12" },
        { key: "类型 ", value: "15：00" },
        { key: "发布时间", value: "12人" },
        { key: "讲解日期", value: "2010-10-10" },
        { key: "讲解时间", value: "2010-10-10" },
        { key: "申请就餐", value: "2010-10-10" },
        { key: "报名时间", value: "2010-10-10" },
        { key: "完成时间", value: "2010-10-10" },
        { key: "观众", value: "2010-10-10" },
        { key: "讲解时长", value: "2010-10-10" },
        { key: "积分", value: "2010-10-10" },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
.img {
  width: 500px;
  height: 312.5px;
}
</style>
